"use strict";
exports.__esModule = true;
//# sourceMappingURL=error-log.type.js.map